import request from '@/utils/request'

//漏洞提交
export function loopholeSubmit(data) {
    return request({
      url: '/api/security/v2/sa/collect/loophole/submit',
      method: 'post',
      data: data
    })
}
